import Box from "@memorang/ui/src/components/Box";
import CustomAvatar from "@memorang/ui/src/components/CustomAvatar";
import type { TextStyle } from "react-native";
/* -----------------UI--------------- */
import { Avatar, List, Text } from "react-native-paper";
import type { Style } from "react-native-paper/lib/typescript/components/List/utils";
import { useAppTheme } from "../../useAppTheme";

export type LeaderboardListItemProps = {
	title: string;
	rank?: number;
	xp: string;
	hasDivider?: boolean;
	image: string;
	textStyle?: TextStyle;
	avatarType?: "initials" | "identicon";
	isCurrentUser?: boolean;
	avatarTittle?: string;
	isStatic?: boolean;
};

const LeaderboardListItem = (props: LeaderboardListItemProps) => {
	const {
		rank,
		title,
		xp,
		image,
		textStyle,
		avatarTittle,
		avatarType,
		isStatic = false,
	} = props;
	const theme = useAppTheme();
	const renderRight = (p: {
		color: string;
		style?: Style;
	}) => (
		<List.Icon
			{...p}
			icon={() => (
				<Text variant="labelSmall" style={{ color: textStyle?.color }}>
					{`${xp?.toLocaleString() ?? 0} XP`}
				</Text>
			)}
		/>
	);

	const renderLeft = (p: { color: string; style: Style }) => {
		return (
			<Box flexDirection="row" alignItems="center" {...p}>
				<Box
					style={{
						alignItems: "center",
						justifyContent: "center",
						width: 20,
						height: 16,
					}}
				>
					{rank && (
						<Text variant="bodySmall" style={{ color: textStyle?.color }}>
							{rank}
						</Text>
					)}
				</Box>
				<List.Icon
					{...p}
					icon={() => (
						<>
							{avatarType || !image ? (
								<Avatar.Text
									size={40}
									label={avatarTittle ?? (title ? title[0] : "")}
								/>
							) : (
								<CustomAvatar size={40} avatar={image} />
							)}
						</>
					)}
					style={p.style}
				/>
			</Box>
		);
	};

	const listItemContent = (
		<List.Item
			title={title}
			style={{
				backgroundColor: isStatic
					? theme.colors.primaryContainer
					: theme.colors.surface,
				borderWidth: 1,
				borderColor: theme.colors.surfaceVariant,
				borderRadius: 8,
			}}
			titleStyle={{
				...(textStyle ?? {}),
			}}
			right={renderRight}
			left={renderLeft}
		/>
	);

	return listItemContent;
};

export default LeaderboardListItem;
